import { lorem, random } from "faker/locale/en_US";

import { defaultNoteStatuses } from "../../../root/defaultConfiguration";
import type { ContactNote } from "../../../types";
import type { Db } from "./types";
import { randomDate } from "./utils";

export const generateContactNotes = (db: Db, size = 3): ContactNote[] => {
  return Array.from(Array(size).keys()).map((id) => {
    const contact = db.contacts[id % db.contacts.length] || db.contacts[0];
    const date = randomDate(new Date(contact.first_seen));
    contact.last_seen =
      date > new Date(contact.last_seen)
        ? date.toISOString()
        : contact.last_seen;
    return {
      id,
      contact_id: contact.id,
      text: lorem.paragraph(),
      date: date.toISOString(),
      sales_id: contact.sales_id ?? 0,
      status: random.arrayElement(defaultNoteStatuses).value,
    };
  });
};
